module.exports = __webpack_public_path__ + "img/8912317.jpg";